import { type FC } from 'react';
import { IconButton } from '@chakra-ui/react';
import type { ButtonSocmedProps } from './types';
import { VARIANT } from './constants';
import Image from 'next/image';

export const ButtonSocmed: FC<ButtonSocmedProps> = ({ variant, ...props }) => {
  return (
    <IconButton 
      translate="no"
      icon={
        <Image
          src={VARIANT[variant].icon}
          width="24"
          height="24"
          alt=""
        />
      }
      bg="shade09"
      p="10px"
      height="auto"
      borderRadius="8px"
      aria-label=""
      _hover={{
        bg: 'shade09',
      }}
      _focus={{
        bg: 'shade09',
      }}
      {...props}
    />
  )
}
